import type { BreadcrumbItem } from './Breadcrumbs';

// See https://developers.google.com/search/docs/appearance/structured-data/breadcrumb#structured-data-type-definitions
interface SchemaListItem {
  '@type': 'ListItem';
  position: number;
  name: string;
  item?: string;
}

export interface BreadcrumbSchema {
  '@type': 'BreadcrumbList';
  itemListElement: Array<SchemaListItem>;
}

const generateSchemaListItem = (breadcrumb: BreadcrumbItem, index: number): SchemaListItem => {
  return {
    '@type': 'ListItem',
    position: index + 1,
    name: breadcrumb.label,
    ...(breadcrumb.href && { item: breadcrumb.href }),
  };
};

export const buildBreadcrumbSchema = (breadcrumbs: Array<BreadcrumbItem>): BreadcrumbSchema => ({
  '@type': 'BreadcrumbList',
  itemListElement: breadcrumbs.map(generateSchemaListItem),
});
